@use '../../styling/typography.scss' as *;

.ChooseTime {
  @extend %font-family-primary;

  display: grid;
  grid-template-columns: auto auto auto auto; // hour min sec timezone
  column-gap: 0.5em;
  align-items: center;
}
